import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@algoan/dashboard/store/store';
import { AccountType } from '@algoan/dashboard/model';
import { formatGroupedCashFlows } from '../formatter/grouped-cash-flows-formatter';
import { latestAnalysisSelector } from '@algoan/dashboard/store/selectors';

export const groupedCashFlowsSelector = createSelector(
  latestAnalysisSelector,
  (state: RootState) => state.account.accounts.some((account) => account.type === AccountType.CREDIT_CARD),
  (analysis, hasCreditCardAccount) =>
    typeof analysis !== 'undefined' ? formatGroupedCashFlows(analysis, hasCreditCardAccount) : undefined,
);
